export default __webpack_public_path__ + "img/bsp-logo-two.37530554.png";